import { SetupIdentificationComponent } from '../components/setup-identification/setup-identification.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from '../../../shared/shared.module';
import { EditSetupRoutingModule } from './edit-setup-routing.module';
import { EditSetupComponent } from './edit-setup.component';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SettingModuleRouting } from '../components/setting-module/setting-module-routing.module';

@NgModule({
  imports: [
    CommonModule,
    SetupIdentificationComponent,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    MatIconModule,
    MatTooltipModule,
    DragDropModule,
    EditSetupRoutingModule,
    SettingModuleRouting
  ],
  declarations: [EditSetupComponent]
})
export class EditSetupModule {}
